import { queryOptions, useQuery } from "@tanstack/react-query";

import { getGeneralConfig } from "~/data/general/general.service";

const configQuery = queryOptions({
  queryKey: ["general"],
  queryFn: () => getGeneralConfig(),
  staleTime: Infinity,
});

export function useConfigQuery() {
  return useQuery(configQuery);
}

export function useConfig() {
  return useConfigQuery().data;
}
